import React from 'react';

//---------- IMPORTANT NOTES ----------//
/*
    1) ALL SVG COMPONENTS USE PROPS FOR WIDTH, HEIGHT, AND FILL (COLOR).
    2) SOME SVG COMPONENTS HAVE FUNCTIONS ASSOCIATED TO THEM OR STYLES FROM MODULAR SCSS FILES
        IN THESE CASES, THE FUNCTION AND/OR CLASSNAMES MUST BE PASSED AS A PROP, FOR EXAMPLE:
        <ExampleIcon 
            width="5" 
            height="5" 
            fill="red" 
            classNameProp={styles["example-class"]} 
            onClick={this.exampleFunction} 
        />
     NOTE THAT UNDER EACH COMPONENT IF PROPS MUST BE PASSED IN, THE STYLE AND/OR FUNCTION IS PROVIDED FOR YOU
*/
//---------- IMPORTANT NOTES ----------//

//----- START NavBar.js -----//
export const MyAccountIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '20'}
    height={props.height ? props.height : '20'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-person-circle'
    viewBox='0 0 16 16'>
    <path d='M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z' />
    <path
      fillRule='evenodd'
      d='M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z'
    />
  </svg>
);

export const PlusCircleDottedIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '20'}
    height={props.height ? props.height : '20'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-plus-circle-dotted ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
  </svg>
);

export const PlusCircleFilledIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '20'}
    height={props.height ? props.height : '20'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-plus-circle-fill ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
  </svg>
);

export const MyProfileIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '20'}
    height={props.height ? props.height : '20'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-person me-1'
    viewBox='0 0 16 16'>
    <path d='M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z' />
  </svg>
);

export const AddUserIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '20'}
    height={props.height ? props.height : '20'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-person-plus me-1'
    viewBox='0 0 16 16'>
    <path d='M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z' />
    <path
      fillRule='evenodd'
      d='M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z'
    />
  </svg>
);

export const NewWindowIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '20'}
    height={props.height ? props.height : '20'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-window-stack me-1'
    viewBox='0 0 16 16'>
    <path d='M4.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM6 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z' />
    <path d='M12 1a2 2 0 0 1 2 2 2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2 2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10ZM2 12V5a2 2 0 0 1 2-2h9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1Zm1-4v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8H3Zm12-1V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2h12Z' />
  </svg>
);
//----- END NavBar.js -----//

//----- START Sidebar.js, notifications.js -----//
export const DashboardIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-columns-gap'
    viewBox='0 0 16 16'>
    <path d='M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z' />
  </svg>
);

export const MyTasksIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-list-task'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z'
    />
    <path d='M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z' />
    <path
      fillRule='evenodd'
      d='M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z'
    />
  </svg>
);

export const LsRequestIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-file-text-fill'
    viewBox='0 0 16 16'>
    <path d='M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5 4h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z' />
  </svg>
);

export const ReportTrackingIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-calendar3'
    viewBox='0 0 16 16'>
    <path d='M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z' />
    <path d='M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z' />
  </svg>
);

export const ClexIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-book-half'
    viewBox='0 0 16 16'>
    <path d='M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z' />
  </svg>
);

export const ProclamationRequestIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-award-fill'
    viewBox='0 0 16 16'>
    <path d='m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864 8 0z' />
    <path d='M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z' />
  </svg>
);

export const StaffDirectoryIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-person-lines-fill'
    viewBox='0 0 16 16'>
    <path d='M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z' />
  </svg>
);

export const CitationRequestIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-trophy-fill'
    viewBox='0 0 16 16'>
    <path d='M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935z' />
  </svg>
);

export const FloorPlanIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-signpost-split-fill'
    viewBox='0 0 16 16'>
    <path d='M7 16h2V6h5a1 1 0 0 0 .8-.4l.975-1.3a.5.5 0 0 0 0-.6L14.8 2.4A1 1 0 0 0 14 2H9v-.586a1 1 0 0 0-2 0V7H2a1 1 0 0 0-.8.4L.225 8.7a.5.5 0 0 0 0 .6l.975 1.3a1 1 0 0 0 .8.4h5v5z' />
  </svg>
);

export const PlayVideoTutorialsIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-collection-play'
    viewBox='0 0 16 16'>
    <path d='M2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3m2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1m2.765 5.576A.5.5 0 0 0 6 7v5a.5.5 0 0 0 .765.424l4-2.5a.5.5 0 0 0 0-.848z' />
    <path d='M1.5 14.5A1.5 1.5 0 0 1 0 13V6a1.5 1.5 0 0 1 1.5-1.5h13A1.5 1.5 0 0 1 16 6v7a1.5 1.5 0 0 1-1.5 1.5zm13-1a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5h-13A.5.5 0 0 0 1 6v7a.5.5 0 0 0 .5.5z' />
  </svg>
);

export const DataTeamExplorerIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-clipboard2-data-fill'
    viewBox='0 0 16 16'>
    <path d='M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5' />
    <path d='M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585q.084.236.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5q.001-.264.085-.5M10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm4-3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1' />
  </svg>
);

export const OutboundLinkIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-box-arrow-up-right'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5'
    />
    <path
      fillRule='evenodd'
      d='M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z'
    />
  </svg>
);

export const ChevronCompactDown = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '16'}
    height={props.height ? props.height : '16'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-chevron-compact-down'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67'
    />
  </svg>
);
//----- END Sidebar.js, notifications.js -----//

//----- END CentralStaff.js -----//
export const UserProfileCircleIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-person-circle'
    viewBox='0 0 16 16'>
    <path d='M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z' />
    <path
      fillRule='evenodd'
      d='M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z'
    />
  </svg>
);
//----- END CentralStaff.js -----//

//----- START UpdateLsRequestPopup.js -----//
export const RightArrowTableHeaderIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '30'}
    height={props.height ? props.height : '30'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-arrow-right-short'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z'
    />
  </svg>
);
//----- END UpdateLsRequestPopup.js -----//

//----- START TableHeader.js -----//
export const ChevronUpFillIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '12'}
    height={props.height ? props.height : '12'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-caret-up-fill'
    viewBox='0 0 16 16'>
    <path d='m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z' />
  </svg>
);

export const ChevronDownFillIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '12'}
    height={props.height ? props.height : '12'}
    fill='currentColor'
    className='bi bi-caret-down-fill'
    viewBox='0 0 16 16'>
    <path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z' />
  </svg>
);
//----- END TableHeader.js -----//

//----- START LsRequestTable.js, LsInfoDisplay.js -----//
export const ThreeDotsVertical = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-three-dots-vertical'
    viewBox='0 0 16 16'>
    <path d='M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z' />
  </svg>
);

export const DupSearchBtnIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-binoculars-fill'
    viewBox='0 0 16 16'>
    <path d='M4.5 1A1.5 1.5 0 0 0 3 2.5V3h4v-.5A1.5 1.5 0 0 0 5.5 1zM7 4v1h2V4h4v.882a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V13H9v-1.5a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5V13H1V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V4zM1 14v.5A1.5 1.5 0 0 0 2.5 16h3A1.5 1.5 0 0 0 7 14.5V14zm8 0v.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V14zm4-11H9v-.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5z' />
  </svg>
);

export const LsrRequestActivationBtnIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-send-check'
    viewBox='0 0 16 16'>
    <path d='M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372zm-2.54 1.183L5.93 9.363 1.591 6.602z' />
    <path d='M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686' />
  </svg>
);

export const PaperClipIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-paperclip'
    viewBox='0 0 16 16'>
    <path d='M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z' />
  </svg>
);

export const UploadFileBtnIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-cloud-arrow-up-fill'
    viewBox='0 0 16 16'>
    <path d='M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0z' />
  </svg>
);

export const ArrowRepeatIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-arrow-repeat ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9' />
    <path
      fillRule='evenodd'
      d='M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z'
    />
  </svg>
);

export const EmptyCircleIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-circle ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16' />
  </svg>
);

export const HourglassTopIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-hourglass-top ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M2 14.5a.5.5 0 0 0 .5.5h11a.5.5 0 1 0 0-1h-1v-1a4.5 4.5 0 0 0-2.557-4.06c-.29-.139-.443-.377-.443-.59v-.7c0-.213.154-.451.443-.59A4.5 4.5 0 0 0 12.5 3V2h1a.5.5 0 0 0 0-1h-11a.5.5 0 0 0 0 1h1v1a4.5 4.5 0 0 0 2.557 4.06c.29.139.443.377.443.59v.7c0 .213-.154.451-.443.59A4.5 4.5 0 0 0 3.5 13v1h-1a.5.5 0 0 0-.5.5m2.5-.5v-1a3.5 3.5 0 0 1 1.989-3.158c.533-.256 1.011-.79 1.011-1.491v-.702s.18.101.5.101.5-.1.5-.1v.7c0 .701.478 1.236 1.011 1.492A3.5 3.5 0 0 1 11.5 13v1z' />
  </svg>
);

export const ArrowReturnLeftIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-arrow-return-left ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5'
    />
  </svg>
);
//----- END LsRequestTable.js, LsInfoDisplay.js -----//

//----- START LsHistory.js, WikiPage.js -----//
export const ClockHistoryIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-clock-history'
    viewBox='0 0 16 16'>
    <path d='M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z' />
    <path d='M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z' />
    <path d='M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z' />
  </svg>
);
//----- END LsHistory.js, WikiPage.js -----//

//----- START SectionFormBar.js -----//
export const ShortArrowDownIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-arrow-down-short'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z'
    />
  </svg>
);

export const ShortArrowUpIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-arrow-up-short'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z'
    />
  </svg>
);
//----- END SectionFormBar.js -----//

//----- START FormTextEditor.js -----//
export const RedoArrowIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-arrow-clockwise'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z'
    />
    <path d='M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z' />
  </svg>
);

export const UndoArrowIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-arrow-counterclockwise'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z'
    />
    <path d='M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z' />
  </svg>
);
//----- END FormTextEditor.js -----//

//----- START PageForm.js -----//
export const PreviewEyeIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-eye-fill'
    viewBox='0 0 16 16'>
    <path d='M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z' />
    <path d='M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z' />
  </svg>
);
//----- END PageForm.js -----//

//----- START WikiSearch.js, ProclamationTable.js, CitationTable.js ----- //
export const PreviewEyeOutlineIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-eye ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z' />
    <path d='M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z' />
  </svg>
);

export const CloseButtonCircleIcon = props => (
  // classNameProp - styles["clex-search-bar-icons"]
  // onClickFunction - formClear
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-x-circle ${props.classNameProp}`}
    viewBox='0 0 16 16'
    onClick={props.onClickFunction}
    onMouseDown={props.onMouseDownFunction}>
    <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
    <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
  </svg>
);
//----- END WikiSearch.js, ProclamationTable.js, CitationTable.js ----- //

//----- START WikiPage.js ----- //
export const PrinterIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    fill='currentColor'
    className='bi bi-printer-fill'
    viewBox='0 0 16 16'>
    <path d='M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z' />
    <path d='M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z' />
  </svg>
);
//----- END WikiPage.js ----- //

//----- END UserProfile.js ----- //
export const PencilFillIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    style={props.style}
    className={`bi bi-pencil-fill ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z' />
  </svg>
);

export const UploadImageIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-card-image'
    style={props.style}
    viewBox='0 0 16 16'>
    <path d='M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z' />
    <path d='M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5h13z' />
  </svg>
);

export const WebcamIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-webcam-fill'
    style={props.style}
    viewBox='0 0 16 16'>
    <path d='M6.644 11.094a.5.5 0 0 1 .356-.15h2a.5.5 0 0 1 .356.15c.175.177.39.347.603.496a7.166 7.166 0 0 0 .752.456l.01.006h.003A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.224-.947l.002-.001.01-.006a3.517 3.517 0 0 0 .214-.116 7.5 7.5 0 0 0 .539-.34c.214-.15.428-.319.603-.496ZM7 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z' />
    <path d='M2 3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H2Zm6 1.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM12.5 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z' />
  </svg>
);

export const CameraCaptureIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-camera-fill ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z' />
    <path d='M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z' />
  </svg>
);

export const ExpandImageArrowsIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-arrows-angle-expand'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z'
    />
  </svg>
);
//----- END UserProfile.js ----- //

//----- START WikiPage.js, CentralStaff.js, UserProfile.js, Sidebar.js, SubjectPage.js ----- //
export const EditPageIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    style={props.style}
    className='bi bi-pencil-square'
    viewBox='0 0 16 16'>
    <path d='M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z' />
    <path
      fillRule='evenodd'
      d='M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z'
    />
  </svg>
);
//----- END WikiPage.js, CentralStaff.js, UserProfile.js, Sidebar.js, SubjectPage.js ----- //

//----- START ReportsTable.js, TagsDisplay.js, UpdateProcRequest.js, CreateNewProcRequest.js, FilterInput.js, UpdateCitationRequest.js, CreateNewCitationRequest.js -----/
export const CloseButtonCircleFillIcon = props => (
  // classNameProp - style["search-button"]
  // onClickFunction - this.onClearFilter
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '16'}
    height={props.height ? props.height : '16'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-x-circle-fill ${props.classNameProp}`}
    viewBox='0 0 16 16'
    onClick={props.onClickFunction}>
    <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z' />
  </svg>
);
//----- END ReportsTable.js, TagsDisplay.js, UpdateProcRequest.js, CreateNewProcRequest.js, FilterInput.js, UpdateCitationRequest.js, CreateNewCitationRequest.js -----/

//----- START ReportsTable.js, ProclamationTable.js, CitationTable.js -----/
export const SortDescendingIcon = props => (
  // classNameProp - ${styles["sort-direction"]
  // sortDirection - "asc" || "desc"
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '28'}
    height={props.height ? props.height : '28'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-sort-${props.sortDirection} ${props.classNameProp}`}
    title={props.titleProp}
    viewBox='0 0 16 16'>
    {props.sortDirection === 'desc' ? (
      <path d='M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z' />
    ) : (
      <path d='M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z' />
    )}
  </svg>
);

export const ChevronUpDownArrowsIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '28'}
    height={props.height ? props.height : '28'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-chevron-expand'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z'
    />
  </svg>
);
//----- END ReportsTable.js, ProclamationTable.js, CitationTable.js -----/ -----/

//----- START NewLsMenu.js-----//
export const ColumnsFilterIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '28'}
    height={props.height ? props.height : '28'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-layout-three-columns'
    viewBox='0 0 16 16'>
    <path d='M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13zM1.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5H5V1H1.5zM10 15V1H6v14h4zm1 0h3.5a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5H11v14z' />
  </svg>
);

export const SliderFilterIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '28'}
    height={props.height ? props.height : '28'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-sliders2'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M10.5 1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4H1.5a.5.5 0 0 1 0-1H10V1.5a.5.5 0 0 1 .5-.5ZM12 3.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm-6.5 2A.5.5 0 0 1 6 6v1.5h8.5a.5.5 0 0 1 0 1H6V10a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5ZM1 8a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 1 8Zm9.5 2a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V13H1.5a.5.5 0 0 1 0-1H10v-1.5a.5.5 0 0 1 .5-.5Zm1.5 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Z'
    />
  </svg>
);

export const OptionsGearIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '16'}
    height={props.height ? props.height : '16'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-gear'
    viewBox='0 0 16 16'>
    <path d='M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z' />
    <path d='M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z' />
  </svg>
);

export const ChevronDownRegularIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '16'}
    height={props.height ? props.height : '16'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-chevron-down'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'
    />
  </svg>
);

export const ChevronUpRegularIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '16'}
    height={props.height ? props.height : '16'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-chevron-up'
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z'
    />
  </svg>
);
//----- END NewLsMenu.js-----//

//----- START WikiSearch.js, CitationTable.js, ProclamationTable.js, ReportsTable.js, NewLsMenu.js -----//
export const SearchIcon = props => (
  // classNameProp - styles["search-button"] (ReportsTable only)
  // onClickFunction - this.onGetReportSearchResult (ReportsTable only)
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '16'}
    height={props.height ? props.height : '16'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-search ${props.classNameProp}`}
    viewBox='0 0 16 16'
    onClick={props.onClickFunction}>
    <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z' />
  </svg>
);
//----- END WikiSearch.js, CitationTable.js, ProclamationTable.js, ReportsTable.js, NewLsMenu.js -----//

//----- START LsHistory.js, PageHistory.js -----//
export const ChevronCompactLeftIcon = props => (
  // styleProp - {verticalAlign: "-.225em"}
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-chevron-compact-left'
    style={props.styleProp}
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223z'
    />
  </svg>
);
//----- END LsHistory.js, PageHistory.js -----//

//----- START SideBar.js, SectionFormBar.js, File.js -----//
export const TrashIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-trash3-fill ${props.classNameProp}`}
    onClick={props.onClickFunction}
    viewBox='0 0 16 16'>
    <path d='M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z' />
  </svg>
);
//----- END SideBar.js, SectionFormBar.js, File.js -----//

export const FileDownloadIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-file-earmark-arrow-down-fill ${props.classNameProp}`}
    id={props.idProp}
    onClick={props.onClickFunction}
    viewBox='0 0 16 16'>
    <path d='M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z' />
  </svg>
);

//----- START NewLsMenu.js, CitationTable.js, SectionFormBar.js, SideBar.js, CitationRequests.js, ProclamationRequest.js, ProclamationTable.js, WikiHome.js, ReportTracking.js -----//
export const PlusIcon = props => (
  <svg
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    viewBox='0 0 8 8'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M4 0C4.13261 0 4.25979 0.0526785 4.35355 0.146447C4.44732 0.240215 4.5 0.367392 4.5 0.5V3.5H7.5C7.63261 3.5 7.75979 3.55268 7.85355 3.64645C7.94732 3.74021 8 3.86739 8 4C8 4.13261 7.94732 4.25979 7.85355 4.35355C7.75979 4.44732 7.63261 4.5 7.5 4.5H4.5V7.5C4.5 7.63261 4.44732 7.75979 4.35355 7.85355C4.25979 7.94732 4.13261 8 4 8C3.86739 8 3.74021 7.94732 3.64645 7.85355C3.55268 7.75979 3.5 7.63261 3.5 7.5V4.5H0.5C0.367392 4.5 0.240215 4.44732 0.146447 4.35355C0.0526785 4.25979 0 4.13261 0 4C0 3.86739 0.0526785 3.74021 0.146447 3.64645C0.240215 3.55268 0.367392 3.5 0.5 3.5H3.5V0.5C3.5 0.367392 3.55268 0.240215 3.64645 0.146447C3.74021 0.0526785 3.86739 0 4 0Z' />
  </svg>
);

export const LogOutIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    onClick={props.onClickFunction}
    className={`bi bi-box-arrow-right ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z'
    />
    <path
      fillRule='evenodd'
      d='M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z'
    />
  </svg>
);

export const PatchQuestionFillIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-patch-question-fill ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M5.933.87a2.89 2.89 0 0 1 4.134 0l.622.638.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01zM7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1.602-2.027c.04-.534.198-.815.846-1.26.674-.475 1.05-1.09 1.05-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.7 1.7 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745.336 0 .504-.24.554-.627' />
  </svg>
);

export const FileUploadIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`'bi bi-file-earmark-arrow-up ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707z' />
    <path d='M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z' />
  </svg>
);
//----- END NewLsMenu.js, CitationTable.js, SectionFormBar.js, SideBar.js, CitationRequests.js, ProclamationRequest.js, ProclamationTable.js, WikiHome.js, ReportTracking.js -----//

//----- START WikiHome.js, CitationRequestsForDay.js, ProcRequestsForDay.js, DueReportsDetails.js, ReviewPage.js -----//
export const ArrowCircleFillLeftIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-arrow-left-circle-fill ${props.classNameProp}`}
    onClick={props.onClickFunction}
    viewBox='0 0 16 16'>
    <path d='M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z' />
  </svg>
);
//----- END WikiHome.js, CitationRequestsForDay.js, ProcRequestsForDay.js, DueReportsDetails.js, ReviewPage.js -----//

//----- START WikiHome.js -----//
export const ArrowCircleFillRightIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-arrow-right-circle-fill ${props.classNameProp}`}
    onClick={props.onClickFunction}
    viewBox='0 0 16 16'>
    <path d='M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z' />
  </svg>
);
//----- END WikiHome.js -----//

//----- START Calendar.js (citation, proclamation, report trackiing), ReportTracking.js, ProcRequestsForDay.js, DueReportsDetails.js, ReportServicePopup.js -----//
export const CalendarIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-calendar3'
    viewBox='0 0 16 16'>
    <path d='M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z' />
    <path d='M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z' />
  </svg>
);
export const ChevronRightIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill='currentColor'
    className={`bi bi-chevron-right ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'
    />
  </svg>
);
export const BoxAndArrowIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '16'}
    height={props.height ? props.height : '16'}
    fill='currentColor'
    className={`bi bi-box-arrow-up-right ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z'
    />
    <path
      fillRule='evenodd'
      d='M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z'
    />
  </svg>
);
export const PeopleCommitteeIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill='currentColor'
    className={`bi bi-people-fill ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z' />
  </svg>
);

export const ProgressBarIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill='currentColor'
    className={`bi bi-bar-chart-steps ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M.5 0a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 .5 0zM2 1.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1z' />
  </svg>
);

export const ClockIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill='currentColor'
    className={`bi bi-clock-fill ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z' />
  </svg>
);

export const FlagFilledIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill='currentColor'
    className={`bi bi-flag-fill ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001' />
  </svg>
);

export const CheckmarkIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill='currentColor'
    className={`bi bi-check-circle-fill ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z' />
  </svg>
);

export const HalfCirlcleIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill='currentColor'
    className={`bi bi-circle-half ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z' />
  </svg>
);

export const ListIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-card-heading'
    viewBox='0 0 16 16'>
    <path d='M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z' />
    <path d='M3 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0-5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1z' />
  </svg>
);

export const CalendarStackIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-view-stacked'
    viewBox='0 0 16 16'>
    <path d='M3 0h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3zm0 8h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3z' />
  </svg>
);

export const CloseButtonNormalIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    viewBox='0 0 16 16'
    className={`bi bi-x ${props.classNameProp}`}
    onClick={props.onClickFunction}>
    <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
  </svg>
);

export const ReportStatusCircle = props => (
  // classNameProp - styles["report-tracking-past-due"] || styles["report-tracking-upcoming"] || styles["report-tracking-received"] || styles["report-tracking-completed"]
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '11'}
    height={props.height ? props.height : '11'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-circle-fill ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <circle cx='8' cy='8' r='8' />
  </svg>
);
//----- END Calendar.js (citation, proclamation, report trackiing), ReportTracking.js, ProcRequestsForDay.js, DueReportsDetails.js, ReportServicePopup.js -----//

//----- START Calendar.js (citation, proclamation, report trackiing), ReportsTable.js, NewLsMenu.js -----//
export const InfoCircleFilledIcon = props => (
  // idProp - completed || received || upcoming || past-due
  // classNameProp - styles["filter-popover-user-guide"]
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '16'}
    height={props.height ? props.height : '16'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-info-circle-fill ${props.classNameProp}`}
    id={props.idProp}
    data-bs-toggle={props.dataBsToggleProp}
    data-bs-target={props.dataBsTargetProp}
    viewBox='0 0 16 16'>
    <path d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z' />
  </svg>
);

export const FunnelFilterIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '18'}
    height={props.height ? props.height : '18'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-funnel-fill'
    viewBox='0 0 16 16'>
    <path d='M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z' />
  </svg>
);

export const CheckIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='currentColor'
    className={`bi bi-check ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path d='M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z' />
  </svg>
);
//----- END Calendar.js (citation, proclamation, report trackiing), ReportsTable.js, NewLsMenu.js -----//

//----- START CreateNewReportDdl.js, CreateNewCitationRequest.js, UpdateCitationRequest.js, CellEditModal.js, UpdateDueReport.js, Calendar.js, PageHistory.js, ToolTip.js, DueReportsDetails.js, UpdateLsRequestPopup.js -----//
export const ToolTipIcon = props => (
  // classNameProp - styles["user-guide-field-icon"]
  // idProp - unit || period
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '12'}
    height={props.height ? props.height : '12'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-info-circle ${props.classNameProp}`}
    id={props.idProp}
    viewBox='0 0 16 16'>
    <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
    <path d='m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z' />
  </svg>
);

export const ShortLeftArrowIcon = props => (
  // classNameProp (Calendar.js only) - styles["arrow-month-selection"]
  // onClickFunction (Calendar.js only) - this.prevMonth
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '30'}
    height={props.height ? props.height : '30'}
    fill={props.fill ? props.fill : 'currentColor'}
    onClick={props.onClickFunction}
    className={`bi bi-arrow-left-short ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z'
    />
  </svg>
);

export const ExclamationPointDiamondIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-exclamation-diamond'
    viewBox='0 0 16 16'>
    <path d='M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z' />
    <path d='M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z' />
  </svg>
);

export const LargeCheckMarkIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '24'}
    height={props.height ? props.height : '24'}
    fill={props.fill ? props.fill : 'currentColor'}
    className='bi bi-check-lg'
    viewBox='0 0 16 16'>
    <path d='M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z' />
  </svg>
);
//----- END CreateNewReportDdl.js, CreateNewCitationRequest.js, UpdateCitationRequest.js, CellEditModal.js, UpdateDueReport.js, Calendar.js, PageHistory.js, ToolTip.js, DueReportsDetails.js, UpdateLsRequestPopup.js -----//

//----- START CreateNewReportDdl.js, AgencyView.js, AllMyLs.js, UpdateDueReport.js, Calendar.js (citation, proclamation, report tracking), MyActiveLs.js, ReviewList.js ReportsTable.js -----//
export const ShortRightArrowIcon = props => (
  // classNameProp (Calendar.js only) - styles["arrow-month-selection"]
  // onClickFunction (Calendar.js only) - this.nextMonth
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '30'}
    height={props.height ? props.height : '30'}
    fill={props.fill ? props.fill : 'currentColor'}
    onClick={props.onClickFunction}
    className={`bi bi-arrow-right-short ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z'
    />
  </svg>
);
//----- END CreateNewReportDdl.js, UpdateDueReport.js, Calendar.js, MyActiveLs.js, ReviewList.js ReportsTable.js -----//

//----- START Found in public/img -----//
export const ChevronLightRightIcon = props => (
  <svg
    aria-hidden='true'
    focusable='false'
    data-prefix='fal'
    data-icon='chevron-right'
    className='svg-inline--fa fa-chevron-right fa-w-8'
    role='img'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 256 512'>
    <path
      fill='currentColor'
      d='M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z'></path>
  </svg>
);

export const NewLSRIcon = props => (
  <svg
    width='174'
    height='172'
    viewBox='0 0 174 172'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clip-rule='evenodd'
      d='M120.667 0V45.6875C120.667 50.1221 124.267 53.75 128.667 53.75H174V163.938C174 168.405 170.433 172 166 172H54C49.5667 172 46 168.405 46 163.938V140.104C75.3722 139.51 99 115.515 99 86C99 56.4854 75.3722 32.4897 46 31.8955V8.0625C46 3.59473 49.5667 0 54 0H120.667ZM174 43V40.9507C174 38.8345 173.167 36.7852 171.667 35.2734L139.033 2.35156C137.533 0.839844 135.5 0 133.367 0H131.333V43H174Z'
      fill='white'
    />
    <path
      d='M69.7419 83.0323V88.9677C69.7419 90.1919 68.7403 91.1935 67.5161 91.1935H51.1935V107.516C51.1935 108.74 50.1919 109.742 48.9677 109.742H43.0323C41.8081 109.742 40.8065 108.74 40.8065 107.516V91.1935H24.4839C23.2597 91.1935 22.2581 90.1919 22.2581 88.9677V83.0323C22.2581 81.8081 23.2597 80.8065 24.4839 80.8065H40.8065V64.4839C40.8065 63.2597 41.8081 62.2581 43.0323 62.2581H48.9677C50.1919 62.2581 51.1935 63.2597 51.1935 64.4839V80.8065H67.5161C68.7403 80.8065 69.7419 81.8081 69.7419 83.0323ZM92 86C92 111.411 71.4113 132 46 132C20.5887 132 0 111.411 0 86C0 60.5887 20.5887 40 46 40C71.4113 40 92 60.5887 92 86ZM83.0968 86C83.0968 65.504 66.496 48.9032 46 48.9032C25.504 48.9032 8.90323 65.504 8.90323 86C8.90323 106.496 25.504 123.097 46 123.097C66.496 123.097 83.0968 106.496 83.0968 86Z'
      fill='white'
    />
  </svg>
);

export const SearchSolidIcon = props => (
  <svg
    aria-hidden='true'
    focusable='false'
    data-prefix='fas'
    data-icon='search'
    className='svg-inline--fa fa-search fa-w-16'
    role='img'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 512 512'>
    <path
      fill='currentColor'
      d='M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z'></path>
  </svg>
);

export const ReactLogoIcon = props => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 841.9 595.3'>
    <g fill='#61DAFB'>
      <path d='M666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V78c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V78.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zM421.2 430c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24 4.7 8 9.5 15.8 14.4 23.4zM420.7 163c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6 0-15.7 22.9-35.6 58.3-50.6 8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zM310 490c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6zM320.8 78.4z' />
      <circle cx='420.9' cy='296.5' r='45.7' />
      <path d='M520.5 78.1z' />
    </g>
  </svg>
);

export const SaveIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '42'}
    height={props.height ? props.height : '42'}
    fill={props.fill ? props.fill : 'currentColor'}
    viewBox='0 0 24 24'>
    <g>
      <path fill='none' d='M0 0h24v24H0z' />
      <path d='M18 19h1V6.828L17.172 5H16v4H7V5H5v14h1v-7h12v7zM4 3h14l2.707 2.707a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm4 11v5h8v-5H8z' />
    </g>
  </svg>
);

//----- END Found in public/img -----//

export const CelebrationIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '36'}
    height={props.height ? props.height : '36'}
    fill={props.fill ? props.fill : 'none'}
    viewBox='0 0 24 24'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-party-popper '>
    <path d='M5.8 11.3 2 22l10.7-3.79' />
    <path d='M4 3h.01' />
    <path d='M22 8h.01' />
    <path d='M15 2h.01' />
    <path d='M22 20h.01' />
    <path d='m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10' />
    <path d='m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17' />
    <path d='m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7' />
    <path d='M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z' />
  </svg>
);

export const RibbonIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '36'}
    height={props.height ? props.height : '36'}
    viewBox='0 0 24 24'
    fill={props.fill ? props.fill : 'none'}
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-ribbon'>
    <path d='M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22' />
    <path d='m12 18 2.57-3.5' />
    <path d='M6.243 9.016a7 7 0 0 1 11.507-.009' />
    <path d='M9.35 14.53 12 11.22' />
    <path d='M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z' />
  </svg>
);

export const BoxArrowInDownIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width ? props.width : '16'}
    height={props.height ? props.height : '16'}
    fill={props.fill ? props.fill : 'currentColor'}
    className={`bi bi-box-arrow-in-down ${props.classNameProp}`}
    viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1z'
    />
    <path
      fillRule='evenodd'
      d='M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z'
    />
  </svg>
);
